// extracted by mini-css-extract-plugin
export var card = "_3y-0";
export var content = "_3y-1";
export var contentLoading = "_3y-2";